import { render, staticRenderFns } from "./TeacherGroupModal.vue?vue&type=template&id=2f3a0fa3&scoped=true&"
import script from "./TeacherGroupModal.vue?vue&type=script&lang=js&"
export * from "./TeacherGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3a0fa3",
  null
  
)

export default component.exports